import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from 'react-hot-toast';
import api from 'state/axios';
import {
    Container,
    Typography,
    TextField,
    Button,
    Box,
    Paper,
    Divider,
} from "@mui/material";
import { LAYOUT_HEIGHT } from 'state/constants';
import PageHeader from "components/PageHeader";


const Contact = () => {
      const navigate = useNavigate();

    const [formData, setFormData] = useState({
        fullName: "",
        email: "",
        message: "",
    });

    const handleChange = (e) => {
        setFormData((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const url = '/contacts/new';
            await api.post(url, formData);

            toast.success("Message sent successfully.");
            setFormData({ fullName: "", email: "", message: "" });

            setTimeout(() => navigate("/"), 2000);
        } catch (error) {
            const message = error.response?.data?.message || error.message || "Failed to submit the form!";
            toast.error(message);
        }
    };


    return (
        <Box>
            <PageHeader/>

            <Container            
                maxWidth="md" 
                sx={{ 
                    minHeight: LAYOUT_HEIGHT,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    mt: 6, 
                    mb: 6, 
                }}
            >
                <Paper
                    elevation={3}
                    sx={{
                        p: 4,
                        borderRadius: 4,
                        width: "100%",
                        maxWidth: "540px", 
                        backgroundColor: 'background.paper',
                    }}
                >
                    <Typography variant="h4" color="primary.main" align="center" gutterBottom>
                        Contact Us
                    </Typography>
                    <Typography variant="h6" align="center" gutterBottom>
                        Email: digitairways@gmail.com
                    </Typography>
                    <Divider sx={{ my: 3 }} />

                    <form onSubmit={handleSubmit}>
                        <Box display="flex" flexDirection="column" gap={3}>
                            <TextField
                                label="Full Name"
                                name="fullName"
                                value={formData.fullName}
                                onChange={handleChange}
                                required
                                fullWidth
                            />
                            <TextField
                                label="Email Address"
                                name="email"
                                type="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                                fullWidth
                            />
                            <TextField
                                label="Message"
                                name="message"
                                multiline
                                rows={5}
                                value={formData.message}
                                onChange={handleChange}
                                required
                                fullWidth
                            />
                            <Button type="submit" variant="contained" color="primary">
                                Send Message
                            </Button>
                        </Box>
                    </form>
                </Paper>
            </Container>
        </Box>
        
    );
};

export default Contact;